// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c42303d4","941":"1e516fd1"}[chunkId] + ".chunk.js";
};